module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAoCAMAAACyy+glAAAAM1BMVEUAAADn5+fq6ura2trc3Nzt7e3m5ubn5+fn5+fn5+fn5+fm5ubo6OjZ2dnm5ub////6+vo/Y40RAAAADXRSTlMA2yTjSQ3s3sGtnXFkzbJ02gAAAHBJREFUOMvl1LsOgCAMheGjcr9U3v9pDYuEqYXBQPznb2japAD0KUpX6kmY1wgkLsDIsYGVY4soxxFI7hDlElZJXVnYpdAsr5EH+gumcr8VYnC1Tc9ifow9Vrcw7tfJ4P5Qs5gfY4/VfYmH3tfQY3wAgkdP4XSRpFQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/dh_icon_kb_default.png
// module id = a2cA
// module chunks = 99